// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-50bddd59]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.self-title[data-v-50bddd59] {\n  font-weight: bolder;\n  margin-bottom: 20px;\n}\n.self-cont[data-v-50bddd59] {\n  font-size: 14px;\n  margin-bottom: 20px;\n  line-height: 30px;\n}", ""]);
// Exports
module.exports = exports;
